import { createSelector } from '@reduxjs/toolkit';
import CartDrawer from 'Common/CartDrawer';
import { Settings } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { appDispatch } from 'slices';
import {
  changeLayout,
  changeLayoutContentWidth,
  changeLayoutMode,
  changeLayoutSemiDark,
  changeLeftSidebarColorType,
  changeSkin,
} from 'slices/layouts/thunk';
import Footer from './Footer';
import Header from './Header';
import RightSidebar from './RightSidebar';

const Layout = ({ children }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = appDispatch();

  const handleToggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const [show, setShow] = React.useState<boolean>(false);
  const handleDrawer = () => setShow(!show);

  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutType: layout.layoutType,
      layoutSemiDarkType: layout.layoutSemiDarkType,
      layoutSkintype: layout.layoutSkintype,
      layoutModeType: layout.layoutModeType,
      layoutDirectionType: layout.layoutDirectionType,
      layoutContentWidthType: layout.layoutContentWidthType,
      layoutSidebarSizeType: layout.layoutSidebarSizeType,
      layoutNavigationType: layout.layoutNavigationType,
      layoutSidebarColorType: layout.layoutSidebarColorType,
      layoutTopbarColorType: layout.layoutTopbarColorType,
    })
  );
  // Inside your component
  const {
    layoutType,
    layoutSemiDarkType,
    layoutSkintype,
    layoutModeType,
    layoutDirectionType,
    layoutContentWidthType,
    layoutSidebarSizeType,
    layoutNavigationType,
    layoutSidebarColorType,
    layoutTopbarColorType,
  } = useSelector(selectLayoutProperties);

  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      layoutSemiDarkType ||
      layoutSkintype ||
      layoutModeType ||
      layoutDirectionType ||
      layoutContentWidthType ||
      // layoutSidebarSizeType ||
      layoutNavigationType ||
      layoutSidebarColorType ||
      layoutTopbarColorType
    ) {
      window.dispatchEvent(new Event('resize'));
      dispatch(changeLayout(layoutType));
      dispatch(changeLayoutSemiDark(layoutSemiDarkType));
      dispatch(changeSkin(layoutSkintype));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutContentWidth(layoutContentWidthType));
      // dispatch(changeLeftsidebarSizeType(layoutSidebarSizeType));
      dispatch(changeLeftSidebarColorType(layoutSidebarColorType));
    }
  }, [
    layoutType,
    layoutSemiDarkType,
    layoutSkintype,
    layoutModeType,
    layoutDirectionType,
    layoutContentWidthType,
    // layoutSidebarSizeType,
    layoutNavigationType,
    layoutSidebarColorType,
    layoutTopbarColorType,
    dispatch,
  ]);

  useEffect(() => {
    document.documentElement.classList.add('scroll-smooth', 'group');
    document.body.classList.add(
      'text-base',
      'bg-body-bg',
      'text-body',
      'font-public',
      'dark:text-zink-100',
      'dark:bg-zink-800',
      'group-data-[skin=bordered]:bg-body-bordered',
      'group-data-[skin=bordered]:dark:bg-zink-700'
    );
    return () => {
      document.documentElement.classList.remove('scroll-smooth', 'group');
      document.body.classList.remove(
        'text-base',
        'bg-body-bg',
        'text-body',
        'font-public',
        'dark:text-zink-100',
        'dark:bg-zink-800',
        'group-data-[skin=bordered]:bg-body-bordered',
        'group-data-[skin=bordered]:dark:bg-zink-700'
      );
    };
  }, []);
  const isHome = window.location.pathname === '/';

  return (
    <>
      <ToastContainer />
      <div className="group-data-[sidebar-size=sm]:min-h-sm group-data-[sidebar-size=sm]:relative flex flex-col min-h-screen">
        {/* <Sidebar
          layoutType={layoutType}
          layoutSidebarSizeType={layoutSidebarSizeType}
        /> */}
        <Header
          // handleToggleDrawer={handleToggleDrawer}
          handleDrawer={handleDrawer}
        />
        <main className="pt-4 flex-grow">
          <div className="containers container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
            {children}
          </div>
        </main>
        {isHome && <Footer />}
      </div>
      {layoutNavigationType === 'hidden' && (
        <div className="fixed items-center bottom-6 right-12 h-header group-data-[navbar=hidden]:flex">
          <button
            type="button"
            className="inline-flex items-center justify-center size-12 p-0 transition-all duration-200 ease-linear rounded-md shadow-lg text-sky-50 bg-sky-500"
            onClick={handleToggleDrawer}
          >
            <Settings className="inline-block size-5" />
          </button>
        </div>
      )}
      <RightSidebar isOpen={isOpen} handleToggleDrawer={handleToggleDrawer} />
      <CartDrawer show={show} handleDrawer={handleDrawer} />
    </>
  );
};

export default Layout;
